import React, { useEffect, useState, useRef, useMemo } from "react";
import { useAuth } from "../contextAPI/AuthContext";
import { useNavigate } from "react-router-dom";
import '../../components/landing-page/lp.css'

const Countdown2 = React.memo(() => {
    const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const intervalRef = useRef(null);
    const nav = useNavigate()
    const { checkToken } = useAuth()
    const calculateTimeLeft = () => {
        const difference = new Date("2024-12-31") - new Date();
        if (difference > 0) {
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / (1000 * 60)) % 60);
            const seconds = Math.floor((difference / 1000) % 60);
            setCountdown({ days, hours, minutes, seconds });
        } else {
            clearInterval(intervalRef.current);
        }
    };

    useEffect(() => {
        calculateTimeLeft();
        intervalRef.current = setInterval(calculateTimeLeft, 1000);
        return () => clearInterval(intervalRef.current);
    }, []);

    const countdownDisplay = useMemo(() => (
        <div className="countdown">
            <div className="time">{countdown.days}</div><span className="text-shadow" style={{ color: "white" }}></span>
            <div className="time">{countdown.hours}</div><span className="text-shadow" style={{ color: "white" }}></span>
            <div className="time">{countdown.minutes}</div><span className="text-shadow" style={{ color: "white" }}></span>
            <div className="time">{countdown.seconds}</div>
        </div>
    ), [countdown]);

    return (
        <div className="countdown-card-main" >
           <div className="countdown-heading">
            <h2 className="f-w-700" style={{color:"white",marginRight:"10px"}}>
                ICO - 
            </h2>
           <h3 style={{marginBottom:"-7px",color:"white"}} className="f-w-700 text-shadow">
             TIME LAPS
            </h3>
           </div>
            {countdownDisplay}
            <div style={{ height: "140px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <button onClick={() => checkToken() ? nav('/swap') : nav('/sign-up')} className="button-LH extra-border" style={{ width: "220px", height: "67px" }}>
                    <h4 className="f-w-700 text-shadow button-text-LH">{checkToken() ? 'BUY TOKENS' : "SIGN UP"}</h4>
                </button>
            </div>
        </div>
    );
});

export default Countdown2;
